import React from "react";

import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClock,
  FaUsers,
} from "react-icons/fa";

import CompactStat from "../ui/CompactStat";

export default function ConvocationsAdminHeader({
  stats,
  loading,
}) {
  return (
    <header className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-[#013E8E] via-[#0757b4] to-indigo-700 shadow-xl shadow-blue-950/10">
      <div className="absolute -right-16 -top-20 h-64 w-64 rounded-full bg-[#4CA82F]/25 blur-3xl" />

      <div className="absolute -bottom-24 left-1/3 h-56 w-56 rounded-full bg-cyan-300/15 blur-3xl" />

      <div className="relative p-5 sm:p-6 lg:p-7">
        <div className="flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
          <div className="max-w-2xl">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-blue-100/80">
              Administration · MonAppliLigue
            </p>

            <h1 className="mt-2 text-2xl font-bold text-white sm:text-3xl">
              Convocations des acteurs
            </h1>

            <p className="mt-2 text-sm leading-6 text-blue-50/85">
              Convoquez individuellement ou par groupe,
              gérez les désinscriptions et consultez les
              inscrits de chaque événement.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3 xl:min-w-[700px] xl:grid-cols-4">
            <CompactStat
              icon={<FaCalendarAlt />}
              label="Événements"
              value={stats.totalEvents}
              loading={loading}
            />

            <CompactStat
              icon={<FaClock />}
              label="À venir"
              value={stats.upcoming}
              accent="emerald"
              loading={loading}
            />

            <CompactStat
              icon={<FaCheckCircle />}
              label="Avec convocations"
              value={stats.withConvocations}
              accent="amber"
              loading={loading}
            />

            <CompactStat
              icon={<FaUsers />}
              label="Convocations"
              value={stats.totalConvocations}
              accent="indigo"
              loading={loading}
            />
          </div>
        </div>
      </div>
    </header>
  );
}